export const PageRoutes = {
  root: '/',
  chat: '/chat',
  choice: '/choice',
  fullAddress: '/full-address',
  leadModeConfirmation: '/confirmation',
  leadModeCheckout: '/full-order',
  leadModeError: '/lead-error',
  landing: '/landing',
  offerWizard: '/offer-wizard',
  plans: '/plans',
  quiz: '/quiz',
  zipPlans: '/zip-plans',
} as const;
